import {useMutation} from '@tanstack/react-query';
import {type} from 'arktype';
import {SessionExpiredError, useLogout, UserStatusArktype} from '~/entities/user';
import {expectOneOf, POST, useHttpClient} from '~/library/network-facade';

export function useKycFinishMutation() {
    const url = 'v1/on_boarding/finish';
    const http = useHttpClient();
    const logout = useLogout();
    return useMutation({
        mutationKey: [url],
        mutationFn: async () => {
            const {status, json} = await http(url, POST()).then(
                expectOneOf({
                    200: type({
                        status: UserStatusArktype,
                    }),
                    401: null,
                })
            );

            switch (status) {
                case 200:
                    return {value: json};
                case 401:
                    logout();
                    throw new SessionExpiredError();
            }
        },
    });
}
